const styles = ({ palette, typography }) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    listStyle: "none",
    margin: 0,
    padding: 0,
    position: "relative",
    zIndex: 10,
  },
});

export default styles;
